export const REACT_APP_API_URL = `${window.REACT_APP_API_URL || 'http://localhost:5000/api'}`
export const IDENTITY_URL = `${window.IDENTITY_URL || 'https://identity.podo-it.nl'}`
export const IDENTITY_REALM = window.IDENTITY_REALM || 'dev'
export const IDENTITY_CLIENT = window.IDENTITY_CLIENT || 'boot-form'
export const FOLDER_LOCATION = window.FOLDER_LOCATION || 'Test upload'
export const BACKEND = window.BACKEND || { key: 'Podo-IT Test', type: 'podoit', value: 'https://test.podo-it.nl', idp: 'vcw' }

export const LOGOUT_ENDPOINT = '/auth/sign_out'
